import { cn } from "@/lib/utils";

export interface BlackPillProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "children"> {
  text: string;
}

const BlackPill: React.FC<BlackPillProps> = ({ text, className, ...props }) => {
  return (
    <span
      className={cn(
        "black-pill py-[1rem] px-[3rem] rounded-[4.55rem] text-[#ffffffd9] uppercase text-[2rem] lg:text-[2.25rem] font-[700] leading-[3.75rem]",
        className
      )}
      {...props}
    >
      {text}
    </span>
  );
};

BlackPill.displayName = "BlackPill";

export default BlackPill;
